import {reactive} from 'vue';

import db from "./db.js";

// Initialisiert ein reaktives Objekt für magazines
export const highlightedMagazines = reactive({});
export const highlightedProjects = reactive({});

export async function reloadHighlights() {


    let processedMagazines = {};
    let processedProjects = {};

    //loop through all values of db.customfields and load them into the highlightedMagazines object
    await db.customfields.each((item) => {

        // projects
        if (!highlightedProjects[item.projectId]) {
            highlightedProjects[item.projectId] = {highlight: true, magazines: {}};
        } else {
            if (!highlightedProjects[item.projectId].highlight) {
                highlightedProjects[item.projectId].highlight = true;
            }
        }

        // magazines
        if (!highlightedMagazines[item.magazineId]) {
            highlightedMagazines[item.magazineId] = {highlight: true, pages: {}};
        } else {
            if (!highlightedMagazines[item.magazineId].highlight) {
                highlightedMagazines[item.magazineId].highlight = true;
            }
        }

        // pages
        if(!highlightedMagazines[item.magazineId].pages[item.pagePosition]) {
            highlightedMagazines[item.magazineId].pages[item.pagePosition] = {
                markets: {},
                products: {},
                highlight: true,
                pageView: {
                    highlight: true,
                }
            };
        } else {
            if(!highlightedMagazines[item.magazineId].pages[item.pagePosition].highlight) {
                highlightedMagazines[item.magazineId].pages[item.pagePosition].highlight = true;
            }
            if(!highlightedMagazines[item.magazineId].pages[item.pagePosition].pageView) {
                highlightedMagazines[item.magazineId].pages[item.pagePosition].pageView = {highlight: true};
            }
        }

        // markets on page
        if(item.marketIds != null || item.marketIds != undefined) {
            const marketIds = JSON.parse(item.marketIds);
            marketIds.forEach((marketId) => {
                if (!highlightedMagazines[item.magazineId].pages[item.pagePosition].markets[marketId]) {
                    highlightedMagazines[item.magazineId].pages[item.pagePosition].markets[marketId] = {highlight: true};
                } else {
                    if (!highlightedMagazines[item.magazineId].pages[item.pagePosition].markets[marketId].highlight) {
                        highlightedMagazines[item.magazineId].pages[item.pagePosition].markets[marketId].highlight = true;
                    }
                }
            });
        }

        // products on page
        if(item.productId != null || item.productId != undefined) {
            if (!highlightedMagazines[item.magazineId].pages[item.pagePosition].products[item.productId]) {
                highlightedMagazines[item.magazineId].pages[item.pagePosition].products[item.productId] = {highlight: true};
            } else {
                if (!highlightedMagazines[item.magazineId].pages[item.pagePosition].products[item.productId].highlight) {
                    highlightedMagazines[item.magazineId].pages[item.pagePosition].products[item.productId].highlight = true;
                }
            }
        }

        if (!processedProjects[item.projectId]) {
            processedProjects[item.projectId] = {highlight: true, magazines: {}};
        }

        if (!processedMagazines[item.magazineId]) {
            processedMagazines[item.magazineId] = {highlight: true, pages: {}};
        }

        if(!processedMagazines[item.magazineId].pages[item.pagePosition]) {
            processedMagazines[item.magazineId].pages[item.pagePosition] = {markets: {}, products: {}, highlight: true};
        }

        if(!processedMagazines[item.magazineId].pages[item.pagePosition].pageView) {
            processedMagazines[item.magazineId].pages[item.pagePosition].pageView = {highlight: true};
        }

        if(item.marketIds != null || item.marketIds != undefined) {
            const marketIds = JSON.parse(item.marketIds);
            marketIds.forEach((marketId) => {
                if(!processedMagazines[item.magazineId].pages[item.pagePosition].markets[marketId]) {
                    processedMagazines[item.magazineId].pages[item.pagePosition].markets[marketId] = {highlight: true};
                }
            });
        }

        if(!processedMagazines[item.magazineId].pages[item.pagePosition].products[item.productId]) {
            processedMagazines[item.magazineId].pages[item.pagePosition].products[item.productId] = {highlight: true};
        }

    });


    await db.listViewChanges.each((item) => {
        if (!highlightedProjects[item.projectId]) {
            highlightedProjects[item.projectId] = {highlight: true, magazines: {}};
        } else {
            if (!highlightedProjects[item.projectId].highlight) {
                highlightedProjects[item.projectId].highlight = true;
            }
        }

        if (!highlightedMagazines[item.magazineId]) {
            highlightedMagazines[item.magazineId] = {highlight: true, pages: {}};
        } else {
            if (!highlightedMagazines[item.magazineId].highlight) {
                highlightedMagazines[item.magazineId].highlight = true;
            }
        }

        if(!highlightedMagazines[item.magazineId].pages[item.pagePosition]) {
            highlightedMagazines[item.magazineId].pages[item.pagePosition] = {
                markets: {},
                products: {},
                highlight: true,
                listView: {
                    highlight: true,
                }
            };
        } else {
            if(!highlightedMagazines[item.magazineId].pages[item.pagePosition].highlight) {
                highlightedMagazines[item.magazineId].pages[item.pagePosition].highlight = true;
            }

            if(!highlightedMagazines[item.magazineId].pages[item.pagePosition].listView) {
                highlightedMagazines[item.magazineId].pages[item.pagePosition].listView = {highlight: true};
            }
        }

        if (!processedProjects[item.projectId]) {
            processedProjects[item.projectId] = {highlight: true, magazines: {}};
        }

        if (!processedMagazines[item.magazineId]) {
            processedMagazines[item.magazineId] = {highlight: true, pages: {}};
        }

        if(!processedMagazines[item.magazineId].pages[item.pagePosition]) {
            processedMagazines[item.magazineId].pages[item.pagePosition] = {markets: {}, products: {}, highlight: true};
        }

        if(!processedMagazines[item.magazineId].pages[item.pagePosition].listView) {
            
            processedMagazines[item.magazineId].pages[item.pagePosition].listView = {highlight: true};
        }
    });




    for (let projectId in highlightedProjects) {
        if (!processedProjects[projectId]) {
            highlightedProjects[projectId].highlight = false;
        }
    }

    for (let magazineId in highlightedMagazines) {
        if (!processedMagazines[magazineId]) {
            highlightedMagazines[magazineId].highlight = false;
        }

        for (let pagePosition in highlightedMagazines[magazineId]?.pages) {
            if (!processedMagazines[magazineId]?.pages[pagePosition]) {
                highlightedMagazines[magazineId].pages[pagePosition].highlight = false;
            }

            for (let marketId in highlightedMagazines[magazineId]?.pages[pagePosition]?.markets) {
                if (!processedMagazines[magazineId]?.pages[pagePosition]?.markets[marketId]) {
                    highlightedMagazines[magazineId].pages[pagePosition].markets[marketId].highlight = false;
                }
            }

            for (let productId in highlightedMagazines[magazineId]?.pages[pagePosition]?.products) {
                if (!processedMagazines[magazineId]?.pages[pagePosition]?.products[productId]) {
                    highlightedMagazines[magazineId].pages[pagePosition].products[productId].highlight = false;
                }
            }

            if (!processedMagazines[magazineId]?.pages[pagePosition]?.pageView) {
                
                highlightedMagazines[magazineId].pages[pagePosition].pageView = {highlight: false};
            }

            if (!processedMagazines[magazineId]?.pages[pagePosition]?.listView) {
                
                highlightedMagazines[magazineId].pages[pagePosition].listView = {highlight: false};
            }
        }
    }



}

reloadHighlights();